exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-size[data-v-03b39243] {\n    min-height: 73px;\n}\n", ""]);

// exports
